import { Skeleton, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';

import {
  Aside,
  Content,
  Container as LayoutContainer,
  Main,
  NavigationMenuContainer,
} from './Layout/Layout.tsx';

const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  flex: 1 0 100%;
`;

const NavigationBar = styled(Skeleton)`
  height: 80px;
`;

const Container = styled(LayoutContainer)`
  flex: 1 0 100%;
`;

const MenuCategory = styled('div')`
  padding-left: 56px;
  margin-bottom: 20px;
`;

const MenuCategoryItems = styled('div')`
  margin-left: 40px;
`;

const SkeletonText = ({ width }: { width: number }) => (
  <Skeleton sx={{ display: 'block' }} variant="text" width={width} />
);

export const LayoutSkeleton: React.FC = ({ children }) => {
  const { t } = useTranslation();

  return (
    <Wrapper aria-label={t('appLoading')}>
      <NavigationBar variant="rectangular" />

      <Container>
        <Aside>
          <NavigationMenuContainer>
            <MenuCategory>
              <SkeletonText width={180} />

              <MenuCategoryItems>
                <SkeletonText width={120} />
                <SkeletonText width={150} />
              </MenuCategoryItems>
            </MenuCategory>

            <MenuCategory>
              <SkeletonText width={150} />

              <MenuCategoryItems>
                <SkeletonText width={80} />
                <SkeletonText width={100} />
              </MenuCategoryItems>
            </MenuCategory>

            <MenuCategory>
              <SkeletonText width={160} />

              <MenuCategoryItems>
                <SkeletonText width={150} />
                <SkeletonText width={120} />
              </MenuCategoryItems>
            </MenuCategory>
          </NavigationMenuContainer>
        </Aside>

        <Content>
          <Main>{children}</Main>
        </Content>
      </Container>
    </Wrapper>
  );
};
